import getDatetimeForTransaction from "@cosine/lib/utils/financial/getDatetimeForTransaction";
import { IEnrichedTransactionModel } from "@cosine/types/api-models";
import getLocalDateFromUTC from "@shared/lib/utils/date/getLocalDateFromUTC";

export default function getDateForTransaction (transaction: IEnrichedTransactionModel): Date {
  return getLocalDateFromUTC(new Date(getDatetimeForTransaction(transaction)));
}
